import { Player } from '@/features/player';
import { parse } from 'qs';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const VideoPage = () => {
  const location = useLocation();
  const searchParams: any = useMemo(() => parse(location.search, { ignoreQueryPrefix: true }), [location.search]);
  const { id, url, cursor, language, duration, source_page, container_id } = useMemo(
    () => searchParams,
    [searchParams],
  );

  const durationValue = useMemo(() => {
    if (duration && !Number.isNaN(Number(duration))) {
      return Number(duration);
    }
  }, [duration]);

  const containerIdValue = useMemo(() => {
    if (container_id && !Number.isNaN(Number(container_id))) {
      return Number(container_id);
    }
  }, [container_id]);

  return (
    <Player
      id={id}
      url={url}
      cursor={cursor}
      duration={durationValue}
      language={language}
      sourcePage={source_page}
      containerId={containerIdValue}
    />
  );
};
